<template>
  <div class="pay-success-page">
    <div class="pay-success-inner">
      <h1>恭喜您，正式开通爱设计企业VIP{{ $route.query.name }}</h1>
      <h1 style="padding-top: 0">感谢您对爱设计的支持！</h1>
      <div class="qrcode">
        <img src="@/assets/image/common/wechat.jpeg" alt="" />
      </div>
      <p class="open-btn" @click="goIndex">开始使用</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "paySuccess",
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  computed: {
    ...mapState(["loginInfo"]),
  },
  methods: {
    goIndex() {
      window.location.href = "https://" + this.loginInfo.current_team_domain;
      // this.staticFunc.toHref("/template");
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-success-page {
  padding-top: 60px;
  background: #ffffff;
  .pay-success-inner {
    width: 1000px;
    height: 649px;
    margin: 50px auto 60px;
    background: url("../../../../assets/image/common/company.png");
    background-size: 100% 100%;
    h1 {
      width: 100%;
      text-align: center;
      font-size: 24px;
      font-weight: 800;
      color: #65430a;
      line-height: 41px;
      padding-top: 58px;
    }
    .qrcode {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 120px;
      height: 120px;
      margin: 40px auto 0;
      background: linear-gradient(127deg, #f5e1cb 0%, #eac8a6 100%);
      border-radius: 8px;
      position: relative;
      img {
        width: 109px;
      }
    }
    .open-btn {
      margin: 194px auto 0;
      width: 150px;
      height: 40px;
      font-size: 22px;
      background: linear-gradient(
        360deg,
        #634dfd 0%,
        #7966fe 41%,
        #8777fb 100%
      );
      border-radius: 21px;
      line-height: 52px;
      cursor: pointer;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
